import axios from "axios";
import useGlobalContext from "../../../hooks/useGlobalContext";
import ModalBackground from "../../../components/common/ModalBackground";
import localize from "../../../common/localize";
import AddOrEditBasicEntity from "../../../components/common/AddOrEditBasicEntity";
import { useState } from "react";

export default function AddOrEditSection({
  show,
  setShow,
  sectionModel,
  onSuccess,
}) {
  const [sectionModelData, setSectionModelData] = useState({ ...sectionModel });
  const { config, EVENTS_API } = useGlobalContext();
  const createOrUpdateSection = async () => {
    const dataResult = await (sectionModelData?.Id > 0
      ? axios.put(
          `${EVENTS_API}/${sectionModelData?.EventId}/evidence-section/${sectionModelData?.Id}`,
          sectionModelData,
          config,
        )
      : axios.post(
          `${EVENTS_API}/${sectionModelData?.EventId}/evidence-section`,
          sectionModelData,
          config,
        ));

    if (
      (dataResult?.Ok || dataResult?.ok || dataResult?.data?.Ok) &&
      onSuccess
    ) {
      onSuccess();
      setShow(false);
    }
  };

  return (
    <ModalBackground
      title={`${sectionModel?.Id > 0 ? localize.edit : localize.add} ${
        localize.section
      }`}
      showModal={show}
      setShowModal={setShow}
      onClickToSubmit={() => createOrUpdateSection()}
      onClickToCancel={() => {
        setShow(false);
      }}
      validators={sectionModelData?.Name?.length === 0}
      isDrawerMode
      hasRequiredValues
      Component={
        <AddOrEditBasicEntity
          model={sectionModelData}
          setModel={setSectionModelData}
          nameMandatory
          customWidth="100%"
        />
      }
    />
  );
}
